// Added by Paul, used in custom-collection-product-grid

if (!customElements.get('get-collection-products')) {
  customElements.define('get-collection-products', class GetCollectionProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.collectionUrl = this.dataset.url;
      this.pageNum = this.dataset.page;
      this.params = new URLSearchParams(window.location.search);
      this.appendElements();
    }

    async appendElements() {
      // Fetches then adds the filters and product cards into page
      const response = await fetch(`${this.collectionUrl}/?section_id=custom-fetch-collection-product-grid&${this.params.toString()}`);
      const htmlText = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(htmlText, 'text/html');
      const productCards = html.getElementById('product-grid-ajax').children;
      const filterDrawer = html.getElementById('drawer-filter-custom');
      const currentFacets = html.getElementById('current-facets-ajax');
      const productCount = html.getElementById('products-count-ajax');
      const pagination = html.getElementById('pagination-ajax');

      this.appendCollection(productCards);
      this.appendFilters(filterDrawer);
      this.appendCurrentFacets(currentFacets);
      this.appendProductCount(productCount);
      this.appendPagination(pagination);
      this.filterCloseButton(filterDrawer);
    }

    appendCollection(productCards) {
      if (productCards.length > 0) {
        document.getElementById('product-grid-ajax').append(...productCards);
        this.nextElementSibling.style.display = 'none';
      }
    }

    appendFilters(filterDrawer) {
      document.getElementById('drawer-filter-custom').innerHTML = filterDrawer.innerHTML;
    }

    appendCurrentFacets(currentFacets) {
      document.getElementById('current-facets-ajax').innerHTML = currentFacets.innerHTML;
    }

    appendProductCount(productCount) {
      document.getElementById('products-count-ajax').innerHTML = productCount.innerHTML;
    }

    appendPagination(pagination) {
      const metaobject = location.pathname.split('/')[2];
      document.getElementById('pagination-ajax').innerHTML = pagination.innerHTML.replaceAll(
        'href="/collections/',
        `href="/pages/${metaobject}/`
      );
    }

    filterCloseButton(filterDrawer) {
      const origFacets = document.querySelector('#drawer-filter-custom');
      const closeBtn = Array.from(origFacets.querySelectorAll('[data-close]'));
      const overlay = origFacets.querySelector('[data-overlay]');

      [...closeBtn, overlay].forEach((c) => {
        c.addEventListener('click', (event) => {
          event.preventDefault();
          removeTrapFocus();
          const parentElement = event.currentTarget.closest('[data-parent]');
          parentElement.classList.remove('is-open');
          document.body.classList.remove('overflow-hidden');
        });
      });
    }
  });
}
